import { createRootRoute, Outlet } from '@tanstack/react-router'
import { BackToTop } from '@/components/ui/back-to-top'

export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
      <BackToTop />
    </>
  ),
})
